// extracted by mini-css-extract-plugin
export var label = "_6x-1";
export var reminder = "_6x-0";